import _ from 'lodash'
import $ from 'jquery'
import {Libs} from 'eyes-lib/es'
import * as Store from './modules/store'
import * as ShareFunc from './modules/sharefunc'

const {nvl, registToGlobal} = Libs
const {fx} = ShareFunc

$(function () {

	//カレンダー表示
	calenderShow();

	//料金区分を変更した時
	$(function () {
		$("#priceCategory").change(function () {
			calenderShow();
		});
	});

});

/**
 * カレンダー描画
 * @description カレンダーに値セット
 *
 */
function calenderShow(type = "nomal") {

	const targetElem = $(".CalAjax");

	const code1 = $("#CODE1").val();
	const code2 = $("#CODE2").val();
	const code3 = $("#CODE3").val();
	const branchcd = $("#BRANCH").val();
	const agentcd = $("#AGENT").val();
	const category = nvl($("#priceCategory").val());
	const roomType = $(".SelectRoomType .Active").attr("data-roomtype"); //選択 部屋タイプ
	var month = $(".SelectMonth .Active").attr("data-month"); //選択 月
	var fromDate = String(targetElem.data("fromdate"));
	var toDate   = String(targetElem.data("todate"));
	var debugFlag   = String(targetElem.data("debug"));
	var all = "";
	var sdate = "";

	if(nvl(roomType)==""){
		//初期表示設定
		// var now = new Date();
		// var format = 'YYYYMM';
		// format = format.replace(/YYYY/g, String(now.getFullYear()));
		// format = format.replace(/MM/g, ('0' + (now.getMonth() + 1)).slice(-2));
		// month = format;
		sdate = String($("#paramYM").val())+"01";
	}else{
	/**月が選ばれていない場合は全期間 */
		if(nvl(month)==""){
			all = "1";
		}else{
			sdate = month+"01";
		}
	}

	fx.loadingStart({target: '.CalAjax'})
	.then(()=>{
		targetElem.load(
			"calendar",
			{
				'CODE1': code1,
				'CODE2': code2,
				'CODE3': code3,
				'BRANCH': branchcd,
				'AGENT': agentcd,
				'ROOMTYPE': roomType,
				'SDATE': sdate,
				'FROMDATE': fromDate,
				'TODATE': toDate,
				'ALL': all,
				'CATEGORY': category,
				'DSP': debugFlag
			},
			function(data, status, xhr) {
				$("#log").append("status = " + status + "<br>");                   // error
				$("#log").append("xhr.status = " + xhr.status + "<br>");           // 404
				$("#log").append("xhr.statusText = " + xhr.statusText + "<br>");   // Not Found
				fx.loadingEnd()	
			}
		);
	})


}

registToGlobal('calenderShow', calenderShow)
